export function createConversationMessageSnapshot(conversations = []) {
  return new Map(conversations.map(conversation => [
    String(conversation.id),
    conversation.lastMessage?.id == null ? null : String(conversation.lastMessage.id),
  ]));
}

export function findNewIncomingMessages(previousSnapshot, conversations = [], currentUserId) {
  if (!previousSnapshot || currentUserId == null) return [];

  return conversations.flatMap((conversation) => {
    const message = conversation.lastMessage;
    if (!message?.id || !message.senderUserId || String(message.senderUserId) === String(currentUserId)) {
      return [];
    }

    const conversationId = String(conversation.id);
    const messageId = String(message.id);
    if (previousSnapshot.get(conversationId) === messageId) return [];

    return [{
      conversationId,
      messageId,
      senderName: conversation.participant?.nombreCompleto || 'Usuario',
      body: message.body || message.preview || 'Te envió un mensaje',
    }];
  });
}

export function getChatNoticeMode({ hidden, chatRouteActive, permission }) {
  if (hidden) return permission === 'granted' ? 'system' : 'none';
  if (chatRouteActive) return 'none';
  return 'in-app';
}

export function sumUnreadCounts(conversations = []) {
  return conversations.reduce((total, conversation) => {
    const unreadCount = Number(conversation?.unreadCount || 0);
    return total + (Number.isFinite(unreadCount) && unreadCount > 0 ? unreadCount : 0);
  }, 0);
}
